import * as st from './styles.module.scss';


export const Tickets = (): JSX.Element => {
	return (
		<div className={st.tickets}>
			<span>Мой билет</span>
		</div>
	)
};

